import { type SmartCallFlowBuilderStore } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/store/SmartCallFlowBuilderStore'
import { SmartCallFlowBuilderContext } from './context'
import {
  type ISmartCallFlowBuilderUiProps,
  SmartCallFlowBuilderUi,
} from './ui/SmartCallFlowBuilderUi'

type ISmartCallFlowBuilderProps = {
  store: SmartCallFlowBuilderStore
} & ISmartCallFlowBuilderUiProps

export const SmartCallFlowBuilder = ({ store, ...props }: ISmartCallFlowBuilderProps) => {
  return (
    <SmartCallFlowBuilderContext.Provider value={store}>
      <SmartCallFlowBuilderUi {...props} />
    </SmartCallFlowBuilderContext.Provider>
  )
}
